// src/components/ContactUs.js
import React, { useState } from "react";
import { supabase } from "../supabaseClient";
import "./ContactUs.css";
import HobbliInfoLayout from "./HobbliInfoLayout";

export default function ContactUs() {
  const [topic, setTopic] = useState("Report Bug");
  const [customTopic, setCustomTopic] = useState("");
  const [message, setMessage] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [sending, setSending] = useState(false);
  const [success, setSuccess] = useState(null);

  const handleSubmit = async (e) => {
      e.preventDefault();
      setSending(true);
      setSuccess(null);

      const finalTopic = topic === "Custom" ? customTopic : topic;

      try {
        const res = await fetch("/api/send-contact-message", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            topic: finalTopic,
            message,
            userEmail: userEmail || null,
          }),
        });

        let data;
        try {
          data = await res.json();
        } catch {
          throw new Error(`Server returned ${res.status} but response is not JSON`);
        }

        if (!res.ok) throw new Error(data.error || "Server error");

        setSuccess(true);
        setMessage("");
        setCustomTopic("");
        setUserEmail("");
        setTopic("Report Bug");
      } catch (err) {
        console.error(err);
        setSuccess(false);
      }

      setSending(false);
    };


  return (
    <HobbliInfoLayout
      eyebrow="About & Support"
      title="Contact & Support"
      intro="Found a bug, have a suggestion, or need help? Send us a message and give us enough detail to point you in the right direction."
    >

        <form onSubmit={handleSubmit} className="contact-form">
          <label>Topic</label>
          <select
            value={topic}
            onChange={(e) => setTopic(e.target.value)}
          >
            <option>Report Bug</option>
            <option>Suggestions</option>
            <option>General Question</option>
            <option value="Custom">Custom Topic</option>
          </select>

          {topic === "Custom" && (
            <>
              <label>Custom Topic</label>
              <input
                type="text"
                value={customTopic}
                onChange={(e) => setCustomTopic(e.target.value)}
                placeholder="Enter a topic"
                required
              />
            </>
          )}

          <label>Your Message</label>
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            required
            placeholder="Type your message here..."
          />

          <label>Your Email (optional)</label>
          <input
            type="email"
            value={userEmail}
            onChange={(e) => setUserEmail(e.target.value)}
            placeholder="Enter your email if you'd like a reply"
          />

          <button type="submit" disabled={sending}>
            {sending ? "Sending..." : "Send Message"}
          </button>

          {success === true && (
            <p className="success-message">Your message has been sent!</p>
          )}
          {success === false && (
            <p className="error-message">There was an error sending your message. Please try again later.</p>
          )}
        </form>
    </HobbliInfoLayout>
  );
}
